<template>
        <div class="warp">
            <breadcrumb :back="true" :crubList="[{name:'担保服务管理'},{name:'经开区中小担申请列表',goback:true},{name:'经开区中小担申请详情'}]" :title="'经开区中小担申请详情'"/>
            <!-- 主体内容 -->
            <!-- 用户明细 -->
            <div class="box">
               <el-card class="basic box_card" header="提交信息" shadow="never">
                 <el-row>
                  <el-col :span="8">
                    <div class="child">
                            <div class="name">申请人姓名：</div>
                            <div class="content">{{detailInfo.applicant}}</div>
                        </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="child">
                            <div class="name">联系手机号：</div>
                            <div class="content">{{detailInfo.contactPhone}}</div>
                        </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="child">
                            <div class="name">公司全称：</div>
                            <div class="content">{{detailInfo.applyCompany}}</div>
                        </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="child">
                            <div class="name">说明：</div>
                            <div class="content">{{detailInfo.applyRemark}}</div>
                        </div>
                  </el-col>
                  <el-col :span="8">
                   <div class="attachment">
                            <div class="name">附件：</div>
                            <ul class="content">
                                <li v-for="(item,i) in detailInfo.fileList" :key="i">
                                    <span>{{item.fileName}}</span><i class="el-icon-download" @click="opens(item)"></i>
                                </li>
                            </ul>
                        </div>
                  </el-col>
                  <el-col :span="8">
                      <div class="child">
                            <div class="name">提交时间：</div>
                            <div class="content">{{detailInfo.createTime}}</div>
                        </div>
                  </el-col>
                  <el-col :span="8" v-if="ishide">
                      <div class="child">
                            <div class="name">是否同意《信息采集协议》：</div>
                            <div class="content">是</div>
                        </div>
                  </el-col>
                  
                </el-row>
              </el-card>
              <el-card class="basic box_card mt16" header="担保进度信息" shadow="never">
                 <el-row>
                  <el-col :span="8">
                    <div class="child">
                            <div class="name">担保进度：</div>
                            <div class="content">{{detailInfo.rateValue}}</div>
                        </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="child">
                            <div class="name">放款金额：</div>
                            <div class="content">{{detailInfo.amount}}</div>
                        </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="child">
                            <div class="name">说明：</div>
                            <div class="content">{{detailInfo.checkExplanation}}</div>
                        </div>
                  </el-col>
                  <el-col :span="8">
                   <div class="child">
                            <div class="name">更新账号：</div>
                            <div class="content">{{detailInfo.modifyUserName}}</div>
                        </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="child">
                            <div class="name">更新时间：</div>
                            <div class="content">{{detailInfo.updateTime}}</div>
                        </div>
                  </el-col>
                </el-row>
              </el-card>
              
            </div>
        </div>
</template>

<script>
import breadcrumb from '../../components/breadcrumb';
import {onDownload} from "@/utils/common";
export default {
    components:{
        breadcrumb
    },
    data(){
        return{
            tab:'1',//选项卡
            id:'',//详情id
            detailInfo:{
                applicant:"",
                contactPhone:"",
                applyCompany:"",
                applyRemark:"",
                fileList:[],
                createTime:"",
                amount:"",
                checkExplanation:"",
                modifyUserName:"",
                updateTime:""
            },
      ishide:false,
        }
    },
    methods:{
        opens({fileName,filePath}){
          const formData = new window.FormData()
          formData.append('fileName', filePath)
          onDownload(formData,fileName)
       },
        //获取数据
        async getData(){
         const {code,data,msg} = await this.$axiosc.get('backstage/vouch/apply/details/'+this.id)
          if (code == 200) {            
              this.detailInfo = data;
          } else {
              this.$alert(msg)
          }
        }
    },
    created(){        
        this.id=this.$route.params.id;
        this.ishide=this.$route.query.ishide;
    },
    mounted(){
        this.getData();
    }
}
</script>

<style lang="scss" scoped>
.warp{
    height:100%;
    overflow: hidden;
}
.box{
    height:calc(100% - 40px);
    overflow-x: hidden;
    overflow-y: auto;
    // margin-top: 20px;
    &_card{
      border:none;
      &::v-deep{
        .el-card__header{
          font-size: 16px;
          color: #262626;
          padding:14px 22px !important;
          border-bottom-color:#E5E5E5;
        }
        .el-card__body{
          padding:24px 25px !important;
        }
      }
    }
}
.basic{
  color:$font;
  font-size: 14px;
  font-weight: 400;
  line-height: 40px;
  // background: #fff;
  .el-col{
    margin: 10px 0;
  }
  .child{
    color:#595959;
  }
}
.main{
  background: transparent !important;
  padding:0 !important;
}
</style>